import { useState, useEffect } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { PieChart } from "react-minimal-pie-chart";
import CanvasJSReact from "@canvasjs/react-charts";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function BubbleChart1(props) {
  const [items, setitems] = useState([]);

  const color = ["#22594E", "#2F7D6D", "#3DA18D", "#69C2B0", "#A1D9CE"];

  useEffect(() => {
    if (props.items) {
      props.items.map((m) => {
        m.y = m.orderCount;
        m.label = m.name;
        // delete m.id;
        delete m.name;
        delete m.orderCount;
        return m;
      });
      setitems(props.items);
    }
  }, [props.items]);

  const options = {
    // animationEnabled: true,
    // exportEnabled: true,
    // theme: "dark2", // "light1", "dark1", "dark2"
    // title: {
    //   text: "Trip Expenses",
    // },
    data: [
      {
        type: "pie",
        legendText: "{label}",
        toolTipContent: "{label}: <strong>{y}</strong>",
        indexLabel: "{id}",
        indexLabelPlacement: "inside",
        // indexLabel: "{id}",
        startAngle: -90,
        dataPoints: items,
      },
    ],
  };

  return (
    <Box sx={{ width: "20%", display: "flex" }}>
      <CanvasJSChart options={options} />
    </Box>
  );
}
